import { useCallback, useState } from 'react'

export const useOnBomClick = ({ callbackFn }) => {
  const [materialSelected, setMaterialSelected] = useState('')
  const onBomClick = useCallback(
    (kit) => {
      if (kit.MaterialNumber === materialSelected) {
        setMaterialSelected(undefined)
      } else {
        setMaterialSelected(kit.MaterialNumber)
      }
      callbackFn?.()
    },
    [materialSelected]
  )
  return { materialSelected, onBomClick, setMaterialSelected }
}
